<template lang="pug">
  .lesson-list
    lesson-list(
      v-if="course && unit"
      :course="course"
      :unit="unit"
      @fetch-unit="fetchUnit"
    )
    v-skeleton-loader.fill-width(
      v-else
      type=`card-heading,
        list-item-two-line@10
      `
    )
</template>

<script>
import LessonList from '../../../components/Lessons/LessonList.vue';

export default {
  components: {
    LessonList,
  },
  props: {
    course: { type: Object, required: true },
  },
  data() {
    return {
      unit: null,
    };
  },
  created() {
    this.fetchUnit();
  },
  methods: {
    async fetchUnit() {
      const { item: unit } = await this.$api.courses.courseUnitShow(
        this.course.id,
        this.$route.params.unitId,
        { expand: 'lessons,tasks,user_passed' },
      );
      this.unit = unit;
    },
  },
};
</script>
